import { Component } from '@angular/core';
import { NativeEnvironmentService } from '../../services/native-environment.service';
import {
  OPEN_SOURCE_DATA_IOS,
  OPEN_SOURCE_DATA_ANDROID,
  OpenSourceOS,
} from './open-source-data';

@Component({
  templateUrl: './settings-open-source-page.component.html',
  styleUrl: './settings-open-source-page.component.scss',
})
export class SettingsOpenSourcePageComponent {
  public infoList: any;

  constructor(private _nativeEnvironmentService: NativeEnvironmentService) {
    const os: OpenSourceOS = this._nativeEnvironmentService.os;
    if (os === 'ios') {
      this.infoList = OPEN_SOURCE_DATA_IOS;
    } else {
      this.infoList = OPEN_SOURCE_DATA_ANDROID;
    }
  }
}
